export default {
      id: "LWS-9px-usage",
      viewBox: "0 0 60 9",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#LWS-9px",
      toString: function () {
        return this.url;
      }
    }